import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { Game } from '../../Core'

import { FormattedMessage } from 'react-intl'

import * as selectors from '../../Mars/Mining/mining.selectors'
import * as tutorialSelectors from '../tutorial.selectors'

import * as tutorialActions from '../tutorial.actions'

import IndicatorContainer from '../../Mars/Indicators/IndicatorContainer'
import SessionCounter from '../../Mars/Components/SessionCounter'
import PointsAlert from '../../Mars/PointsManager/PointsAlert'
import BasicToast from '../../Mars/Toast/BasicToast'
import DocumentsButton from '../../Mars/Documents/DocumentsButton/index'
import SettingsMenuButton from '../../Mars/Settings/SettingsMenuButton'
import HelpButton from '../../Mars/Settings/HelpButton'
import UIButton from '../../Mars/UI/UIButton'
import UserShield from '../../Mars/Components/UserShield'
import MapButton from '../../Mars/Map/MapButton'

/**
 *  Pop up showed when you have finished the game
 */
class MiningScreensContainer extends React.Component {
  /**
   *  Component constructor.
   */
  constructor(props) {
    super(props)
    this.state = {
      growOutClass: '',
    }
  }

  continueToMine() {
    const { changeMiningScreen, clearFeedBack, removeQuestion } = this.props

    clearFeedBack()
    changeMiningScreen('mining_select_screen')
    removeQuestion(null)
  }

  renderBackButton() {
    return (
      <div onClick={() => this.continueToMine()}>
        <div className="btn--back">
          <span className="icon-back"></span>
        </div>
      </div>
    )
  }

  renderCloseButton() {
    const { removeScreen } = this.props
    return (
      <UIButton
        icon={'icon-colonia'}
        id={'colony'}
        position={'position--absolute right bottom z-index1'}
        action={() => {
          removeScreen('mining_screen')
        }}
      />
    )
  }

  removeScreen() {
    const { changeMiningScreen, removeScreen } = this.props

    this.setState({ growOutClass: 'bounceOut-animation' })
    setTimeout(() => {
      removeScreen('mining_screen')
      changeMiningScreen('mining_select_screen')
    }, 1000)
  }

  render() {
    const { components, screens, currentUser, miningScreen, groupData, indicators, miningUI } =
      this.props
    const { growOutClass } = this.state
    if (!miningScreen) {
      return
    }
    const component = screens[miningScreen].component
    const Viewer = components[component]

    const ColonyShield = ({ currentUser }) => (
      <div>
        <UserShield shield={currentUser.colonyShield} />
        <div className="player--position">
          <div className="player--label">
            <FormattedMessage id="ranking.position" defaultMessage="position" />
          </div>
          <div className="player--position__item">{currentUser.position}º</div>
        </div>
      </div>
    )

    return (
      <div
        className={`container ${growOutClass} ${
          !growOutClass ? 'growIn-animation' : ''
        } background background--mina z-index1`}
      >
        <PointsAlert />
        <BasicToast />
        <div className="content">
          <div className="mina background--mina__canvas">
            {miningUI.userShield && <ColonyShield currentUser={currentUser} />}
            {miningUI.indicators && (
              <IndicatorContainer
                indicators={indicators}
                isVisitor={false}
                position="position--absolute center top z-index5"
              ></IndicatorContainer>
            )}
            <Viewer />
            {miningUI.documentsButton && <DocumentsButton />}
            <SettingsMenuButton />
            {miningUI.helpButton && <HelpButton />}
            {miningUI.mapButton && <MapButton action={() => this.removeScreen()} />}
            <div className="position--absolute left top">
              {miningScreen !== 'tutorial_mining_select_screen' && this.renderBackButton()}
            </div>
            {miningUI.sessionCounter && (
              <SessionCounter dateTime={groupData.endSessionDate} turn={1} maxTurns={3} />
            )}
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  // all mocked :)
  removeQuestion: bindActionCreators(tutorialActions.removeQuestion, dispatch),
  removeScreen: bindActionCreators(tutorialActions.removeScreen, dispatch),
  clearFeedBack: bindActionCreators(tutorialActions.clearFeedBack, dispatch),
  changeMiningScreen: bindActionCreators(tutorialActions.changeMiningScreen, dispatch),
})

const mapStateToProps = (state) => ({
  // Not need to mock
  components: Game.selectors.getModuleComponents(state),
  screens: selectors.getAllMiningScreens(state),

  // Mocked
  groupData: tutorialSelectors.getGroupData(state),
  userData: tutorialSelectors.getUserData(state),
  indicators: tutorialSelectors.getIndicators(state),
  currentUser: tutorialSelectors.getCurrentUser(state),
  miningScreen: tutorialSelectors.getMiningScreen(state),
  miningUI: tutorialSelectors.getMiningUI(state),
})

MiningScreensContainer.propTypes = {
  changeMiningScreen: PropTypes.func,
  currentUser: PropTypes.object,
  groupData: PropTypes.object,
  miningScreen: PropTypes.string,
  removeScreen: PropTypes.func,
  indicators: PropTypes.array,
  clearFeedBack: PropTypes.func,
  removeQuestion: PropTypes.func,
  screens: PropTypes.object,
  components: PropTypes.object,
  miningUI: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(MiningScreensContainer))
